import type { MapViewProps } from '@deck.gl/core';
import { MapController, MapView } from '@deck.gl/core';
import type { MjolnirEvent } from 'mjolnir.js';

class CustomMapController extends MapController {
  constructor(...args: ConstructorParameters<typeof MapController>) {
    super(...args);
    this.events = ['click', 'pointermove'];
  }

  handleEvent = (e: MjolnirEvent) => {
    if (
      (e.target instanceof HTMLDivElement ||
        e.target instanceof HTMLButtonElement) &&
      (e.target.attributes.getNamedItem('mapboxgl-children') != null ||
        e.target.classList.contains('mapboxgl-marker'))
    ) {
      return super.handleEvent(e);
    }
    return false;
  };
}

export default class CustomMapView extends MapView {
  constructor(opts: MapViewProps) {
    super(opts);
  }
  get ControllerType() {
    return CustomMapController;
  }
}
